/**
 * 获取FAQ最新消息数量
 */
export const getNewMessageNumber = '/faq/get/newMessageNumber';
/**
 * 获取FAQ 类型数据列表
 */
export const getCategoryList = '/faq/get/categoryList';
/**
 * 获取 FAQ 内容数据列表
 */
export const getFAQContentList = '/faq/get/contentList';
/**
 * 获取 FAQ 内容数据
 */
export const getFAQContentInfo = '/faq/get/contentInfo';
/**
 * 提交客服问题
 */
export const submitQuestion = '/faq/submit/question';
/**
 * 提交文本类型客服消息
 */
export const submitQuestionMessagesText = '/faq/submit/questionMessages/text';
/**
 * 提交图片附件类型客服消息
 */
export const submitQuestionMessagesAttr = '/faq/submit/questionMessages/attr';
/**
 * 获取用户历史客服问题列表数据
 */
export const getHistoryQuestionList = '/faq/get/history/questionList';
/**
 * 获取客服问题历史消息列表数据
 */
export const getHistoryQuestionMessagesList = '/faq/get/history/questionMessagesList';
/**
 * 提交用户问题满意度评价
 */
export const submitEvaluate = '/faq/submit/evaluate';
/**
 * 提交未登陆用户客服问题
 */
export const saveUnknownQu = '/faq/save/unknown/question';
/**
 * 检索 FAQ 内容数据列表
 */
export const searchFaq = '/faq/search/content';
/**
 * 提交举报作弊信息
 */
export const report = '/faq/report/cheating';
/**
 * 修改 FAQ 未读消息状态
 */
export const updateMsgStatus = '/faq/update/message/status';
/**
 * 查询客服系统使用版本
 */
export const getFaqVersion = '/faq/v2/get/version';